
import { defineComponent, PropType } from "vue";
import { HSV } from "../../utils/color";

const gradient = "linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)";

export default defineComponent({
  props: {
    modelValue: { type: Object as PropType<HSV>, required: true },
  },
  emits: [
    "update:modelValue",
  ],
  data: () => ({
    gradient,
    moveHandler: null as ((e: PointerEvent) => void) | null,
    upHandler: null as (() => void) | null,
  }),
  beforeUnmount() {
    if (this.upHandler) {
      this.upHandler();
    }
  },
  methods: {
    startDrag(evt: PointerEvent): void {
      if (this.moveHandler) return;
      const rect = (this.$refs.container as HTMLDivElement).getBoundingClientRect();
      this.moveHandler = (e: PointerEvent) => {
        const left = (e.clientX - rect.left) / rect.width;
        this.$emit("update:modelValue", {
          h: 359.7 * Math.min(1, Math.max(0, left)), // #FF0001 max
          s: this.modelValue.s,
          v: this.modelValue.v,
        });
      };
      this.upHandler = () => {
        if (this.moveHandler) {
          document.removeEventListener("pointermove", this.moveHandler);
          this.moveHandler = null;
        }
        if (this.upHandler) {
          document.removeEventListener("pointerup", this.upHandler);
          document.removeEventListener("pointerleave", this.upHandler);
          this.upHandler = null;
        }
      };
      document.addEventListener("pointermove", this.moveHandler);
      document.addEventListener("pointerup", this.upHandler);
      document.addEventListener("pointerleave", this.upHandler);
      this.moveHandler(evt);
    },
  },
});
